// Auto-generated - Updated with cleaned people data and corrected counts
// Overall database statistics

export const statsData = {
  "totalDocuments": 23124,
  "documentsWithPeople": 21986,
  "documentsWithLocations": 16860,
  "uniquePeople": 24795,
  "uniqueLocations": 9846,
  "uniqueDates": 8083,
  "topPerson": [
    "Jeffrey Epstein",
    5198
  ],
  "topLocation": [
    "New York",
    2048
  ],
  "topWord": [
    "document",
    30472
  ]
};
